import { Tag, TagVariant } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { LocalizedCurrencyValue, LocalizedText } from '@mews/framework';
import { DatavizPalette, MatrixCellColor } from '@mews/b2b-ui';
import { Amount, DisplayBillState } from '@mews-commander/data-access';

const THRESHOLD_COLOR: MatrixCellColor = { color: 'warning', intensity: 0.2 };

const mapStatusToVariant: Record<DisplayBillState, TagVariant> = {
    [DisplayBillState.Paid]: 'basicSubtle',
    [DisplayBillState.Unpaid]: 'info',
    [DisplayBillState.PartiallyPaid]: 'basicBold',
    [DisplayBillState.Overdue]: 'warning',
    [DisplayBillState.Open]: 'lime',
    [DisplayBillState.Closed]: 'danger',
    [DisplayBillState.ProcessingPayment]: 'lavender',
};

export const mapStatusToColor: Record<DisplayBillState, DatavizPalette> = {
    [DisplayBillState.Paid]: 'green',
    [DisplayBillState.Unpaid]: 'blue',
    [DisplayBillState.PartiallyPaid]: 'disabled',
    [DisplayBillState.Overdue]: 'orange',
    [DisplayBillState.Open]: 'green',
    [DisplayBillState.Closed]: 'red',
    [DisplayBillState.ProcessingPayment]: 'purple',
};

export const mapStatusToTextKey: Record<DisplayBillState, Mews.TextKey> = {
    [DisplayBillState.Paid]: TextKey.Paid,
    [DisplayBillState.Unpaid]: TextKey.Unpaid,
    [DisplayBillState.PartiallyPaid]: TextKey.PartiallyPaid,
    [DisplayBillState.Overdue]: TextKey.Overdue,
    [DisplayBillState.Open]: TextKey.Open,
    [DisplayBillState.Closed]: TextKey.Closed,
    [DisplayBillState.ProcessingPayment]: TextKey.Processing,
};

export const getStatusCell = (status: DisplayBillState | null) => {
    if (!status) return null;

    const variant = mapStatusToVariant[status];
    const textKey = mapStatusToTextKey[status];

    return (
        <Tag data-test-id="tag" variant={variant} outline>
            {textKey ? <LocalizedText textKey={textKey} /> : null}
        </Tag>
    );
};

export const getAgingCellColor = (status: DisplayBillState, hasAmount: boolean) =>
    status === DisplayBillState.Overdue && hasAmount ? THRESHOLD_COLOR : undefined;

export const getLocalizedCurrencyValueCell = (currencyValue?: Amount | null) => {
    if (!currencyValue || !currencyValue?.value) return null;

    return currencyValue ? <LocalizedCurrencyValue value={currencyValue} /> : null;
};
